export default __webpack_public_path__ + "static/media/906.77e679c9.jpg";